import request from '@/utils/request'

export const list = (type: string): Promise<any> => {
    return request.get(`/web/categories`, {params: {type}})
}
